import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const Hero = () => {
    const components = document.querySelectorAll('[data-component="hero"]');

    components.forEach(component => {
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            modules: [Pagination, Navigation, Autoplay],
            loop: true,
            slidesPerView: 1,
        });
    });
};

export default Hero;

if(document.querySelectorAll('[data-component="hero"]').length) {
    Hero();
}